import React, { useEffect, useState } from "react";
import { ErrorMessage, Formik } from "formik";
import {
  Alert,
  Button,
  Form,
  Spinner,
  Card,
  Row,
  Col,
  Table,
  Accordion,
  InputGroup,
  Modal,
} from "react-bootstrap";
import NumberFormat from 'react-number-format';
import moment from "moment";
import * as Yup from "yup";
import { getInputClasses } from "../../../_utils/getInputclasses";
import AlertError from "../../../components/AlertError";
import { Divider } from "@material-ui/core";
import { GetUser } from "../../../../_metronic/_helpers";
import { getLetterMovsByCase, storeLetterMov, updateLetterMvByCase } from "../../services/letterMovsService";
import { getByAgentId } from "../../services/agentsCatalogService";
import { getAllByCase as getDocumentsByCase, markSent } from "../../services/documentsService";
import { shallowEqual, useSelector } from "react-redux";
import {isNotEmpty} from "../../../_utils/checkObjectEmpty";

export const AuthLetters = (props) => {
  return (
    <>
      <Card>
        <Card.Header>
          <Accordion.Toggle
            as={Button}
            variant="link"
            eventKey={props.eventKey}
          >
            Cartas de Autorizacion
          </Accordion.Toggle>
          <i className={`fa ${props.icon}`} style={{position:"absolute", right:"0", marginRight:"15px", marginTop:"10px" }}></i>
        </Card.Header>
        <Accordion.Collapse eventKey={props.eventKey}>
          <Card.Body>
            <ContentAuthLetters {...props} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
};

export const ContentAuthLetters = (props) => {
  return (
    <>
      <Alert
        variant="dark"
        className="text-center mt-4"
        style={{ fontSize: "14px" }}
      >
        {props.titleAlert ? props.titleAlert : 'Cartas de Autorizacion'}
      </Alert>

      <Card>
        <Card.Body>
          <FormAuthLetters {...props} />
        </Card.Body>
      </Card>
    </>
  );
};

const FormAuthLetters = ({ hideAmountLetter = false, hideAmountMedicalFees = true, ...props }) => {
  const { data } = props;
  const [isSubstitution, setIsSubstitution] = useState(false);
  const [showAmountMedicalFees, setShowAmountMedicalFees] = useState(false);
  const [userAuth] = useState({ ...GetUser().user });
  const [letterMovs, setletterMovs] = useState([]);
  const [authorizationDocuments, setAuthorizationDocuments] = useState([]);
  const [inputKey, setInputKey] = useState("");
  const [showAuthorizationModal, setShowAuthorizationModal] = useState(false);
  const [selectedAuthorizationLetters, setSelectedAuthorizationLetters] = useState({});
  const [agentInputId, setAgentInputId] = useState("");
  const [agentName, setAgentName] = useState("");
  const [agentPromoter, setAgentPromoter] = useState("");
  const [agentEmail, setAgentEmail] = useState("");
  const [agentError, setAgentError] = useState("");
  const [sendAuthorizationError, setSendAuthorizationError] = useState("");
  const [isSendingAuthorization, setIsSendingAuthorization] = useState(false);

  moment.locale('es');

  const amountRequired = Yup.string().required("El campo es requerido");

  const validationSchema = Yup.object().shape({
    file: Yup.mixed()
      .required("El campo es requerido")
      .test("fileFormat", "Solo se permiten archivos PDF", (value) => {
        return value && ["application/pdf"].includes(value.type);
      }),
    amount: !props.typeModule && props.typeModule !== "Honorarios medicos" ? amountRequired : null,
    letterIden: Yup.string().required("El campo es requerido"),
    letterType: Yup.string().required("El campo es requerido"),
    amountMedicalFees: showAmountMedicalFees ? Yup.string().required("El campo es requerido") : null,
  });

  const getAllByCase = () =>  {
    getLetterMovsByCase(data.id).then(res => {
      if (props.typeModule && props.typeModule === "Honorarios medicos") {
        res.data = res.data?.filter( currLetterMov => currLetterMov.typeModule === "Honorarios medicos");
      } else {
        res.data = res.data?.filter( currLetterMov => currLetterMov.typeModule !== "Honorarios medicos");
      }

      setletterMovs(res.data);
    });
  }

  const loadAuthorizationDocuments = () => {
    getDocumentsByCase(data.id).then((response) => {
      setAuthorizationDocuments(response.data || []);
    });
  };

  useEffect(() => {
    if (isNotEmpty(data)) {
      getAllByCase();
      loadAuthorizationDocuments();
      setAgentInputId(data?.agent?.agentId || "");
      setAgentName(data?.agent?.agentName || "");
      setAgentPromoter(data?.agent?.promoterEdit || "");
      setAgentEmail(data?.agent?.email || "");
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatToCurrency = amount => "$" + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  const calculateTotalLetters = () => {
    var lastAuthLetter = letterMovs?.filter( letterMov => letterMov.letterType === "Carta de autorizacion").pop();
    let total = letterMovs?.reduce( (total, current) => !current.ignored && current.letterType !== "Carta de autorizacion" && current.letterType !== "Carta de Autorización Rechazo" ? total = total + Number(current.amount.replace(/[^0-9.-]+/g,"")) : total, 0);
    if (lastAuthLetter && !lastAuthLetter?.ignored)
      return total + Number(lastAuthLetter?.amount.replace(/[^0-9.-]+/g,"")) || 0;
    else
      return total;
  }

  let totalLetters = calculateTotalLetters();

  props.setTotalLetters(totalLetters);

  const calculateTotalAmountMedicalFees = () => {
    return letterMovs?.reduce( (total, current) => total + current.amountMedicalFees, 0);
  }

  let totalAmountMedicalFees = calculateTotalAmountMedicalFees();

  const initialDocument = {
    file: "",
    letterType: "",
    amount: "",
    letterIden: "",
    letterSustitution: "",
    letterSustitutionL: "",
    doctorName: "",
    amountMedicalFees: "",
  };

  const {token} = useSelector(
    ({auth}) => ({
        token: auth.authToken,
    }),
    shallowEqual
  );

  const normalizeDocUrl = (url) => {
    if (!url) return url;
    return url
      .replace("https://bxm.atcplus.com.mx:8080", "")
      .replace("http://bxm.atcplus.com.mx:8080", "");
  };

  const downloadPDF = async (e, urlFile) => {
    e.preventDefault();
    const safeUrl = normalizeDocUrl(urlFile);

    try {
      const response = await fetch(safeUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const txt = await response.text();
        throw new Error(`HTTP ${response.status}: ${txt}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (err) {
      console.error("Error al abrir PDF:", err);
      alert("No se pudo abrir el documento (permisos o sesión).");
    }
  };

  const hasSelectedAuthorizationLetters = Object.values(
    selectedAuthorizationLetters
  ).some(Boolean);

  const toggleAuthorizationLetter = (letterMovId) => {
    setSelectedAuthorizationLetters((prev) => ({
      ...prev,
      [letterMovId]: !prev[letterMovId],
    }));
  };

  const resetAuthorizationSelection = () => {
    setSelectedAuthorizationLetters({});
  };

  const getAuthorizationDocumentId = (document) => {
    const rawId = document?.id;
    if (rawId === null || rawId === undefined || rawId === "") {
      return null;
    }
    const numericId = Number(rawId);
    return Number.isNaN(numericId) ? null : numericId;
  };

  const getSelectedAuthorizationIds = () =>
    Object.entries(selectedAuthorizationLetters)
      .filter(([, isSelected]) => isSelected)
      .map(([letterMovId]) => Number(letterMovId));

  const hasDocumentSent = (document) => {
    const sentValue = document?.sent ?? document?.sent_at;
    return (
      sentValue !== null &&
      sentValue !== undefined &&
      sentValue !== "" &&
      sentValue !== "null"
    );
  };

  const handleSendAuthorizationEmail = async () => {
    const trimmedAgentId = agentInputId.trim();
    if (!trimmedAgentId) {
      setAgentError("El ID del agente es requerido.");
      return;
    }
    if (agentError) {
      return;
    }

    const selectedIds = getSelectedAuthorizationIds();
    if (selectedIds.length === 0) {
      setSendAuthorizationError("Selecciona al menos una carta.");
      return;
    }

    try {
      setIsSendingAuthorization(true);
      setSendAuthorizationError("");

      await markSent({
        agentId: trimmedAgentId,
        documentIds: selectedIds,
      });

      setAuthorizationDocuments((prev) =>
        prev.map((document) =>
          selectedIds.includes(getAuthorizationDocumentId(document))
            ? { ...document, sent: new Date().toISOString() }
            : document
        )
      );
      setShowAuthorizationModal(false);
      resetAuthorizationSelection();
    } catch (error) {
      setSendAuthorizationError("No se pudo enviar el correo.");
    } finally {
      setIsSendingAuthorization(false);
    }
  };

  const handleAgentIdBlur = async () => {
    const trimmedAgentId = agentInputId.trim();

    if (!trimmedAgentId) {
      setAgentName("");
      setAgentPromoter("");
      setAgentEmail("");
      setAgentError("");
      return;
    }

    try {
      const response = await getByAgentId(trimmedAgentId);
      if (response.data) {
        setAgentInputId(response.data.agentId || trimmedAgentId);
        setAgentName(response.data.agentName || "");
        setAgentPromoter(response.data.promoterEdit || "");
        setAgentEmail(response.data.email || "");
        setAgentError("");
      }
    } catch (error) {
      setAgentName("");
      setAgentPromoter("");
      setAgentEmail("");
      setAgentError("No se encontro el agente con ese ID.");
    }
  };

  const onSubmit = (values, { setStatus, setSubmitting, resetForm }) => {
    setTimeout(() => {
      const wasIgnored = letterMovs.filter(letterMov => letterMov.ignored)
        .some(letterMov => letterMov.letterMovId === parseInt(values.letterSustitution));

      if (wasIgnored) {
        setStatus('Ocurrio algun error al guardar: ya fue sustituida la carta');
        setSubmitting(false);
        return;
      }

      const cleanAmount = values.amountMedicalFees
        ? values.amountMedicalFees.toString().replace(/,/g, '')
        : '0';

      let formData = new FormData();
      formData.append("file", values.file);
      formData.append("userId", userAuth.idUser);
      formData.append("letterType", values.letterType);
      formData.append("amount", values.amount);
      formData.append("letterIden", values.letterIden);
      formData.append("caseId", data.id);
      formData.append("typeModule", props.typeModule || "Cartas de autorizacion");
      formData.append("doctorName", values.doctorName);
      formData.append("amountMedicalFees", cleanAmount);


      storeLetterMov(formData)
        .then( async response => {
          if (values.letterType === "Sustitucion") {
            await updateLetterMvByCase(values.letterSustitution, { ignored: true });
            setIsSubstitution(false);
          }
          await getAllByCase();
          if (props.setTotalLetters) {
            props.setTotalLetters(calculateTotalLetters());
          }

          resetForm();

          setInputKey(Math.random().toString(36));

          setStatus(null);
        })
        .catch( err => setStatus(`Ocurrio algun error al guardar`));

      setSubmitting(false);
    }, 1000);
  }

  const renderDefaultOptions = () => {
      const defaultOptions = [
          {
              value: "",
              text: "Selecciona una opción...",
              hidden: false
          },
          {
              value: "Carta honorarios medicos",
              text: "Carta honorarios medicos",
              hidden: props.typeModule !== "Honorarios medicos"
          },
          {
              value: "Carta de autorizacion",
              text: "CARTA DE AUTORIZACIÓN",
              hidden: props.typeModule === "Honorarios medicos"
          },
          {
              value: "Complementaria",
              text: "Complementaria",
              hidden: props.typeModule === "Honorarios medicos"
          },
          {
              value: "Carta de Autorización Rechazo",
              text: "Carta de Autorización Rechazo",
              hidden: props.typeModule === "Honorarios medicos"
          },
          {
              value: "Sustitucion",
              text: "Sustitucion",
              hidden: false
          }
      ];

        return defaultOptions.map((option, idx) => (
            <option
                key={idx}
                value={option.value}
                hidden={option.hidden}
            >
                {option.text}
            </option>
        ));
    };

  return (
    <>
      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th>Documento</th>
            <th>Usuario</th>
            <td hidden={!props.typeModule && props.typeModule !== "Honorarios medicos"}>Medico tratante</td>
            <th>Fecha</th>
            <th>Tipo de Carta</th>
            <th>Numero de Carta</th>
            <th hidden={hideAmountLetter}>Monto de Carta</th>
            <th hidden={hideAmountMedicalFees}>Monto de Honorarios</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          {letterMovs?.map( (letterMovement, idx) => (
            <tr key={idx} style={{ backgroundColor: letterMovement.ignored ? "#ff6b6b" : "" }}>
              <td>Carta de Autorizacion</td>
              <td>{letterMovement.user?.userName}</td>
              <td hidden={!props.typeModule && props.typeModule !== "Honorarios medicos"}>{letterMovement.doctorName}</td>
              <td>{moment(letterMovement.createdAt).format('DD/MM/YYYY HH:mm:ss A')}</td>
              <td>{letterMovement.letterType}</td>
              <td>{letterMovement.letterIden}</td>
              <td hidden={hideAmountLetter}>${letterMovement.amount}</td>
              <td hidden={hideAmountMedicalFees}>{letterMovement.amountMedicalFees ? `$${letterMovement.amountMedicalFees}` : ''}</td>
              <td>
                <a hidden={letterMovement.ignored} href={letterMovement.urlFile} onClick={(e) => {downloadPDF(e, letterMovement.urlFile)}}>
                  <i className="fas fa-eye"></i>
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="text-lg-right" hidden={hideAmountLetter}>
        Total Cartas: {formatToCurrency(totalLetters)}
      </div>

      <div className="text-lg-right" hidden={hideAmountMedicalFees}>
        Total Honorarios Medicos: {formatToCurrency(totalAmountMedicalFees)}
      </div>

      <Divider className="mt-5 mb-5" />
      { props.showForm && <Formik
        initialValues={initialDocument}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          setFieldValue,
          status,
          isSubmitting,
        }) => (
          <>
            <AlertError status={status} />

            <Form onSubmit={handleSubmit}>
              <Row hidden={props.disabledAll}>
                <Col>
                  <Form.Group controlId="file">
                    <Form.Label>Archivo</Form.Label>
                    <Form.Control
                      key={inputKey || ''}
                      disabled={props.disabledAll}
                      type="file"
                      name="file"
                      accept="application/pdf"
                      onChange={(event) => {
                        setFieldValue("file", event.currentTarget.files[0]);
                      }}
                      className={`${getInputClasses(touched, errors, "file")}`}
                    />
                    <ErrorMessage name="file">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="letterType">
                    <Form.Label>Tipo de Carta *</Form.Label>
                    <Form.Control
                      disabled={props.disabledAll}
                      as="select"
                      name="letterType"
                      value={values.letterType}
                      onChange={(e) => {
                        handleChange(e);
                        const value = e.target.value;
                        value === 'Carta de Autorización Inicial' || value === 'Carta Autorización Corte' || value === 'Autorización Aumento de Suma' || value === 'Carta honorarios medicos' ? setShowAmountMedicalFees(true) : setShowAmountMedicalFees(false);
                        value === "Sustitucion" || value === "Carta Autorización Corte" || value === "Autorización Aumento de Suma" ? setIsSubstitution(true) : setIsSubstitution(false);
                      }}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "letterType"
                      )}`}
                    >
                      {props.letterTypes ? (
                        <>
                          <option value="">SELECCIONA UNA OPCIÓN...</option>
                          {props.letterTypes.map((letterType, idx) => (
                            <option key={idx} value={letterType}>
                              {letterType}
                            </option>
                          ))}
                        </>
                      ) : (
                        renderDefaultOptions()
                      )}
                    </Form.Control>
                    <ErrorMessage name="letterType">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group controlId="letterSustitution" hidden={!isSubstitution}>
                    <Form.Label>Carta a sustituir *</Form.Label>
                    <Form.Control
                      disabled={props.disabledAll}
                      as="select"
                      name="letterSustitution"
                      onChange={handleChange}
                      value={values.letterSustitution}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "letterSustitution"
                      )}`}
                    >
                      <option value="">Selecciona una opcion...</option>
                      {letterMovs?.map( (letterMov, idx) => (
                        <option key={idx} value={letterMov.letterMovId}>{letterMov.letterIden} {!props.typeModule && props.typeModule !== "Honorarios medicos" ? ` - $${letterMov.amount}` : ''}</option>
                      ))}
                    </Form.Control>
                    <ErrorMessage name="letterSustitution">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>
              <Row hidden={props.disabledAll}>
                <Col hidden={hideAmountLetter}>
                  <Form.Group controlId="amount">
                    <Form.Label>Importe Carta Autorizacion *</Form.Label>
                    <InputGroup className="mb-3">
                      <InputGroup.Prepend>
                        <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                      </InputGroup.Prepend>
                      <NumberFormat
                        fixedDecimalScale={true}
                        decimalScale={2}
                        value={values.amount}
                        onChange={handleChange}
                        name="amount"
                        thousandSeparator={true}
                        className={`form-control ${getInputClasses(
                          touched,
                          errors,
                          "amount"
                        )}`}
                      />
                    </InputGroup>
                    <ErrorMessage name="amount">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="letterIden">
                    <Form.Label>Numero de Carta *</Form.Label>
                    <Form.Control
                      name="letterIden"
                      value={values.letterIden}
                      onChange={handleChange}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "letterIden"
                      )}`}
                    >
                    </Form.Control>
                    <ErrorMessage name="letterIden">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group controlId="amountMedicalFees" hidden={!showAmountMedicalFees}>
                    <Form.Label>Importe honorarios medicos *</Form.Label>
                    <InputGroup className="mb-3">
                      <InputGroup.Prepend>
                        <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                      </InputGroup.Prepend>
                      <NumberFormat
                        fixedDecimalScale={true}
                        decimalScale={2}
                        value={values.amountMedicalFees}
                        onChange={handleChange}
                        name="amountMedicalFees"
                        thousandSeparator={true}
                        className={`form-control ${getInputClasses(
                          touched,
                          errors,
                          "amountMedicalFees"
                        )}`}
                      />
                    </InputGroup>
                    <ErrorMessage name="amountMedicalFees">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>

              <Row hidden={!props.typeModule && props.typeModule !== "Honorarios medicos"}>
                <Col>
                  <Form.Group controlId="doctorName">
                    <Form.Label>Medico tratante</Form.Label>
                    <Form.Control
                      disabled={props.disabledAll}
                      as="select"
                      name="doctorName"
                      value={values.doctorName}
                      onChange={handleChange}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "doctorName"
                      )}`}
                    >
                      <option value="">Selecciona una opcion...</option>
                      {props.medicalFees?.map( (medicalFee, idx) => (
                        <option key={idx} value={medicalFee.medicName}>{medicalFee.medicName}</option>
                      ))}
                    </Form.Control>
                    <ErrorMessage name="doctorName">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>

              <Button
                variant="primary"
                type="submit"
                disabled={isSubmitting}
                hidden={props.disabledAll}
              >
                {isSubmitting && (
                  <Spinner
                    as="span"
                    animation="border"
                    variant="dark"
                    size="sm"
                  />
                )}
                Subir Documento
              </Button>
              <Button
                variant="danger"
                type="button"
                hidden
                style={{ marginLeft: "10px" }}
                onClick={() => setShowAuthorizationModal(true)}
              >
                ENVIAR CARTAS DE AUTORIZACION
              </Button>
            </Form>
          </>
        )}
      </Formik> }
      <Modal
        show={showAuthorizationModal}
        onHide={() => {
          setShowAuthorizationModal(false);
          resetAuthorizationSelection();
          setSendAuthorizationError("");
        }}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>ENVIO CARTAS DE AUTORIZACION</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={3}>
                <Form.Group controlId="agentInputId">
                  <Form.Label>ID Agente</Form.Label>
                  <Form.Control
                    type="text"
                    name="agentInputId"
                    value={agentInputId}
                    onChange={(event) => {
                      setAgentInputId(event.target.value);
                      setAgentError("");
                    }}
                    onBlur={handleAgentIdBlur}
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="agentName">
                  <Form.Label>Nombre Agente</Form.Label>
                  <Form.Control
                    type="text"
                    name="agentName"
                    value={agentName}
                    readOnly
                    disabled
                    className="bg-light"
                  />
                </Form.Group>
              </Col>
              <Col md={5}>
                <Form.Group controlId="agentPromoter">
                  <Form.Label>Promotoria</Form.Label>
                  <Form.Control
                    type="text"
                    name="agentPromoter"
                    value={agentPromoter}
                    readOnly
                    disabled
                    className="bg-light"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form.Group controlId="agentEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    name="agentEmail"
                    value={agentEmail}
                    readOnly
                    disabled
                    className="bg-light"
                  />
                </Form.Group>
              </Col>
            </Row>
            {agentError && (
              <Row>
                <Col>
                  <div className="text-danger">{agentError}</div>
                </Col>
              </Row>
            )}
            {sendAuthorizationError && (
              <Row>
                <Col>
                  <div className="text-danger">{sendAuthorizationError}</div>
                </Col>
              </Row>
            )}
          </Form>
          <Divider className="mt-3 mb-3" />
          {authorizationDocuments.length === 0 ? (
            <div className="text-center text-muted">
              No hay cartas de autorizacion disponibles para enviar.
            </div>
          ) : (
            <Table responsive striped bordered hover>
              <thead>
                <tr>
                  <th>Documento</th>
                  <th>Usuario</th>
                  <th>Fecha</th>
                  <th>Tipo de Carta</th>
                  <th>Numero de Carta</th>
                  <th hidden={hideAmountLetter}>Monto de Carta</th>
                  <th hidden={hideAmountMedicalFees}>Monto de Honorarios</th>
                  <th>Selecciona Carta</th>
                </tr>
              </thead>
              <tbody>
                {authorizationDocuments.map((document) => {
                  const documentId = getAuthorizationDocumentId(document);
                  const hasSent = hasDocumentSent(document);
                  return (
                    <tr
                      key={documentId || document?.id}
                      style={{
                        backgroundColor: hasSent ? "#f8d7da" : "#d4edda",
                      }}
                    >
                    <td>Carta de Autorizacion</td>
                    <td>{document.user?.userName}</td>
                    <td>
                      {moment(document.createdAt || document.dateAdd).format(
                        "DD/MM/YYYY HH:mm:ss A"
                      )}
                    </td>
                    <td>{document.documentType}</td>
                    <td>{document.id}</td>
                    <td hidden={hideAmountLetter}></td>
                    <td hidden={hideAmountMedicalFees}>
                      {""}
                    </td>
                    <td className="text-center">
                      <Form.Check
                        type="checkbox"
                        checked={
                          !hasSent &&
                          Boolean(
                            selectedAuthorizationLetters[documentId]
                          )
                        }
                        onChange={() =>
                          toggleAuthorizationLetter(documentId)
                        }
                        disabled={hasSent || documentId === null}
                        aria-label={`Selecciona ${document.id}`}
                      />
                    </td>
                  </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              setShowAuthorizationModal(false);
              resetAuthorizationSelection();
            }}
          >
            CERRAR
          </Button>
          <Button
            variant="primary"
            type="button"
            disabled={!hasSelectedAuthorizationLetters || isSendingAuthorization}
            onClick={handleSendAuthorizationEmail}
          >
            {isSendingAuthorization ? "ENVIANDO..." : "ENVIAR CORREO"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AuthLetters;
